const locale = $('#front').data('front-locale')

const authentication = {
    login: {
        url: '',
        disableLoginInputs() {
            $('#login fieldset, #login button').attr('disabled', 'disabled')
        },
        enableLoginInputs() {
            $('#login fieldset, #login button').removeAttr('disabled')
        },
        loginData() {
            const email = $('#login input[name="email"]').val()
            const password = $('#login input[name="password"]').val()
            const remember = $('#login input[name="remember"]').val()

            return {email, password, remember}
        },
        handleValidationErrors({response}) {
            if (response && response.status === 422) {
                const errors = response.data.errors

                if (errors.email) {
                    $('.login-email .email-errors').text(errors.email.join(';'))
                }

                if (errors.password) {
                    $('.login-password .password-errors').text(errors.password.join(';'))
                }
            }

            if (response && response.status === 403) {
                // console.log(response.data.errors)

                if (response.data.type === 1) {
                    window.location.href = `/${locale}/cannot-login-to-site/${response.data.user_id}`
                } else if (response.data.type === 2) {
                    window.location.href = `/${locale}/registrations/user/${response.data.user_id}`
                } else if (response.data.type === 3) {
                    window.location.href = `/${locale}/password/expired/${response.data.email}`
                }
            }
        },
        init() {
            const $login = $('#login')

            this.url = $login.attr('action')

            $login.on('submit', event => {
                event.preventDefault()
                authentication.toggleLoading('login')
                authentication.clearErrors()
                this.disableLoginInputs()

                axios
                    .post(this.url, this.loginData())
                    .finally(() => {
                        authentication.toggleLoading('login')
                        this.enableLoginInputs()
                    })
                    .then(response => {
                        if (response.data.success) {
                            window.location.href = response.data.intended
                        }
                    })
                    .catch(error => {
                        this.handleValidationErrors(error)
                    })
            })
        },
    },

    register: {
        url: '',
        disableRegisterInputs() {
            $('#register fieldset, #register button').attr('disabled', 'disabled')
        },
        enableRegisterInputs() {
            $('#register fieldset, #register button').removeAttr('disabled')
        },
        registerData() {
            const email = $('#register input[name="email"]').val()
            const password = $('#register input[name="password"]').val()
            const user_type = $('#register select[name="user_type"]')
                .data('select')
                .val()

            const accept_terms = $('#register input[name="accept_terms"]').is(':checked')

            return {email, password, user_type, accept_terms}
        },
        handleValidationErrors({response}) {
            if (response && response.status === 422) {
                const errors = response.data.errors

                if (errors.email) {
                    $('.register-email .email-errors').text(errors.email.join(';'))
                }

                if (errors.password) {
                    $('.register-password .password-errors').text(errors.password.join(';'))
                }

                if (errors.user_type) {
                    $('.register-user_type .user_type-errors').text(errors.user_type.join(';'))
                }

                if (errors.accept_terms) {
                    $('.register-accept_terms .accept_terms-errors').text(
                        errors.accept_terms.join(';'),
                    )
                }
            }

            if (response && response.status === 403) {
                // console.log(response.data.errors)

                if (response.data.type === 1) {
                    window.location.href = `/${locale}/already-registered-on-another-auction-organizer/${response.data.user_id}`
                } else if (response.data.type === 2) {
                    window.location.href = `/${locale}/already-registered-on-auction-platform-operator/${response.data.user_id}`
                }
            }
        },
        showAfterRegistrationContent() {
            $('#login-register .tab-wrap .tab-single.active').removeClass('active')
            $('#login-register .tab-content .tab-content-single.active').removeClass('active')
            $('#login-register .tab-wrap .tab-single[data-content=1]').addClass('active')
            $('#login-register .tab-content .tab-content-single[data-content=3]').addClass('active')
        },
        init() {
            const $register = $('#register')

            this.url = $register.attr('action')
            let registerForm = document.getElementById('register')
            $register.on('submit', event => {
                event.preventDefault()
                authentication.toggleLoading('register')
                authentication.clearErrors()
                this.disableRegisterInputs()

                axios
                    .post(this.url, this.registerData())
                    .finally(() => {
                        authentication.toggleLoading('register')
                        this.enableRegisterInputs()
                    })
                    .then(response => {
                        const $front = $('#front')

                        if (response.data.success) {
                            // fbq('track', 'Lead', {
                            //     value: 9.00,
                            //     currency: $front.data('site-currency')
                            // })
                            // window.location.href = response.data.intended

                            this.showAfterRegistrationContent()
                        }
                    })
                    .catch(error => {
                        // console.log('Login error', error)
                        this.handleValidationErrors(error)
                    })
            })
        },
    },

    init() {
        $('.tab-content-single form').each(function () {
            $(this).validator({
                focus: true,
                disable: false,
            })
        })

        this.login.init()
        this.register.init()
    },

    toggleLoading(type) {
        $(`#${type}-loading`).toggleClass('d-none')
    },

    clearErrors() {
        $('.tab-content-single form .with-errors').empty()
    },
}

authentication.init()
